/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetResponse
 */
export interface AssetResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetResponse
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetResponse
     */
    modelId?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetResponse
     */
    assetTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetResponse
     */
    manufacturerId?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetResponse
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetResponse
     */
    parentAssetId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssetResponse
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetResponse
     */
    assetCategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetResponse
     */
    assetCategoryName?: string;
}

/**
 * Check if a given object implements the AssetResponse interface.
 */
export function instanceOfAssetResponse(value: object): value is AssetResponse {
    return true;
}

export function AssetResponseFromJSON(json: any): AssetResponse {
    return AssetResponseFromJSONTyped(json, false);
}

export function AssetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'modelId': json['modelId'] == null ? undefined : json['modelId'],
        'assetTypeId': json['assetTypeId'] == null ? undefined : json['assetTypeId'],
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'parentAssetId': json['parentAssetId'] == null ? undefined : json['parentAssetId'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'assetCategoryId': json['assetCategoryId'] == null ? undefined : json['assetCategoryId'],
        'assetCategoryName': json['assetCategoryName'] == null ? undefined : json['assetCategoryName'],
    };
}

export function AssetResponseToJSON(json: any): AssetResponse {
    return AssetResponseToJSONTyped(json, false);
}

export function AssetResponseToJSONTyped(value?: AssetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'modelId': value['modelId'],
        'assetTypeId': value['assetTypeId'],
        'manufacturerId': value['manufacturerId'],
        'siteId': value['siteId'],
        'parentAssetId': value['parentAssetId'],
        'externalId': value['externalId'],
        'assetCategoryId': value['assetCategoryId'],
        'assetCategoryName': value['assetCategoryName'],
    };
}

